let bound = false;

export function initAdsetDisclosure(): void {
  if (bound) return;
  bound = true;

  $(document).on("click", "[data-adset-toggle]", function (e) {
    if ($(e.target).closest("a, button").length) return;

    const $row = $(this);
    $row.toggleClass("open");
    $row.next(".ads-sub").toggleClass("open");
  });
}
